import { render, staticRenderFns } from "./LawConsultManage.vue?vue&type=template&id=6097e224&"
import script from "./LawConsultManage.vue?vue&type=script&lang=js&"
export * from "./LawConsultManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports